import { forwardRef } from 'react';
import { useState, useEffect } from 'react';
import { Select, MenuItem, Checkbox, Box, Chip, ListItemText } from '@mui/material';
import API from '@utils/axios';

const MailingListSelect = forwardRef(({ emptyLabel, ...params }, ref) => {
    const [mailingLists, setMailingLists] = useState([]);

    useEffect(() => {
        const fetchMailingLists = async () => {
            try {
                const response = await API.get('/mailing-lists', {
                    params: {
                        sort: 'name',
                        direction: 'asc',
                        per_page: 9999,
                    }
                });
                if (response.data && Array.isArray(response.data.data)) {
                    setMailingLists(response.data.data);
                } else {
                    setMailingLists([]);
                }
            } catch (error) {
                setMailingLists([]);
            }
        };
        fetchMailingLists();
    }, []); // Pas de dépendance, donc le code s'exécute une seule fois

    return (
        params.multiple ? (
            <Select ref={ref} {...params}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => {
                            const mailingList = mailingLists.find((mailingList) => mailingList.id === value);
                            if (!mailingList) return null;
                            return (
                                <Chip label={mailingList.name} key={value} size="small" />
                            );
                        })}
                    </Box>
                )}
            >
                {mailingLists.map((mailingList) => (
                    <MenuItem key={mailingList.id} value={mailingList.id}>
                        {<Checkbox checked={params.value.indexOf(mailingList.id) > -1} />}
                        <ListItemText>{mailingList.name}</ListItemText>
                    </MenuItem>
                ))}
            </Select>
        ) : (
            <Select ref={ref} {...params}>
                {emptyLabel && <MenuItem value="">{emptyLabel}</MenuItem>}
                {mailingLists.map((mailingList) => (
                    <MenuItem key={mailingList.id} value={mailingList.id}>
                        <ListItemText>{mailingList.name}</ListItemText>
                    </MenuItem>
                ))}
            </Select>
        )
    );
});

export default MailingListSelect;